import "../styles/SideMenu.css";
import React from "react";
import SideMenuItem from "./SideMenuItem"
import {MdWork} from "react-icons/md"


function SideMenuItemContainer(props) {
    const items = props.mainItems;

    return (
        <>
            <ul className='nav-main-menu-items'>
                {items.map((item, index) => {
                    return  <SideMenuItem item={item} key={index} index={index} sidebarOpen={props.sidebarOpen} toggleSidebar={props.toggleSidebar}/>
                })}
            < li className='nav-main-menu-text'>
                
                {/* External Career Page */}
                <a size='2em' className="main-menu-name" href="https://ttgi.prevueaps.com/jobs/">
                    <MdWork />
                    <span>Careers</span>
                </a>
               
            </li >
            </ul>

        </>
    );
}
export default SideMenuItemContainer